<script setup lang="ts">
/*
 * The picture area of a tile in the price-list project management — project, template and "Custom
 * price list" tiles alike, in the layout of the series cards in List.vue (picture on white, title below).
 *
 * Two looks (13.10.2026, Christoph): a real cover FILLS the whole area (`fill`), the placeholder keeps
 * the framed area of the series cards. Both are 264px high (framed: pt-12 + 200px + pb-4), so tiles of
 * either kind stay in line. Without a picture, an icon stands in the framed area (the custom tile).
 */
defineProps<{
  src?: string
  alt?: string
  // A real cover: fills the area. Otherwise the picture (the Wilo placeholder) sits in the frame.
  fill?: boolean
  // In place of a picture, in the framed area.
  icon?: string
}>()
</script>

<template>
  <div v-if="fill && src" class="h-[264px] bg-white">
    <img :src="src" :alt="alt || ''" loading="lazy" class="size-full object-cover">
  </div>
  <div v-else class="bg-white hover:bg-white pt-12 pb-4">
    <div class="flex h-[200px]">
      <UIcon v-if="icon" :name="icon" size="64px" class="m-auto text-gunmetal" />
      <img v-else :src="src" :alt="alt || ''" loading="lazy" class="m-auto max-h-[190px]">
    </div>
  </div>
</template>
